/* global API */

import editor from './Editor';
import buttonState from '../../helpers/buttonState';
import promiseTimeout from '../../helpers/promiseTimeout';

const EDIT_CLASS = '.js-edit-media';
const ITEM_CLASS = '.js-media-item';

const Edit = {
  create(node, options) {
    this.options = options;

    $(document).on('click', EDIT_CLASS, this.onEdit.bind(this));
  },

  /**
   * Open image editor
   * @param {Object} e Event object
   * @return {Void}
   */
  onEdit(e) {
    // Get ID for the media item
    this.id = this.getIdForItem(e.currentTarget);

    // Create a modal for the editor
    this.modalId = this.createEditModal(this.id);

    // Modal element shortcut
    this.$modal = $(`#${this.modalId}`);

    // Open the modal
    this.$modal.modal('show');

    this.modalEditor = { ...editor };

    // Get the modal content
    this.getModalContent(this.getURL(API.media.editorUrl, this.id))
      .then((content) => {
        // Show the content in the modal
        this.outputContentToModal(this.modalId, typeof content.data !== 'undefined' ? content.data : 'Geen content');

        this.modalEditor.create(this.$modal, this.options);

        this.$modal.find('[data-toggle="popover"]').popover({
          trigger: 'focus',
        });
      });

    this.createListeners();
  },

  createListeners() {
    this.$modal.on('submit', 'form', (event) => {
      event.preventDefault();

      const form = event.currentTarget;
      const submitButton = form.querySelector('[type="submit"]');

      if (submitButton) {
        buttonState('disabled', submitButton);
      }

      this.saveMedia(this.getURL(API.media.editorUrl, this.id), new FormData(form))
        .then(() => {
          buttonState('saved', submitButton);
          return promiseTimeout(3000);
        })
        .then(() => {
          buttonState('default', submitButton);
        });
    });

    // Remove the modal completely when we're done
    this.$modal.on('hidden.bs.modal', () => {
      this.$modal.remove();

      this.modalEditor.destroy();
    });
  },

  /**
   * Get option from options
   * @param {String} key
   * @param {String} replaceVal
   * @param {String} replaceKey
   * @return {String}
   */
  getURL(url, replaceVal, replaceKey = 'id') {
    if (typeof replaceVal !== 'undefined') {
      return url.replace(`{${replaceKey}}`, replaceVal);
    }

    return url;
  },

  /**
   * Get the ID for the item
   * @param {DOMNode} el
   * @return {String} Media item ID
   */
  getIdForItem(el) {
    return $(el).parents(ITEM_CLASS).data('item-id');
  },

  /**
   * Get the content for the modal
   * @param {String} url
   * @return {Promise}
   */
  getModalContent(url) {
    return window.axios.get(url)
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },

  /**
   * Save media to the server
   * @param {String} url
   * @param {FormData} formData
   * @return {Promise}
   */
  saveMedia(url, formData) {
    formData.append('_method', 'put');

    return window.axios.post(url, formData)
      .catch((err) => {
        console.error(err); // eslint-disable-line
      });
  },

  /**
   * Output content to modal
   * @param {String} modalId
   * @param {String} content
   * @return {Void}
   */
  outputContentToModal(modalId, content) {
    $(`#${modalId}`).find('.js-edit-content').html(content);
  },

  /**
   * Create edit modal elementvaru
   * @param {String} id ID of the media
   * @return {String} ID of the created modal element
   */
  createEditModal(id) {
    $('body').append(`
      <div class="modal" id="edit-modal-${id}" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>

              <div class="js-edit-content">
                <div class="spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `);

    return `edit-modal-${id}`;
  },
};

export default Edit;
